import { observer } from 'mobx-react-lite';
import { useRootStore } from 'stores/RootStore';
import { UserProfile } from 'components/settings/UserProfile';
import { Link, NavigationPage } from 'components/NavigationPage';
import { Account } from 'components/settings/Account';
import { NotificationSettings } from './NotificationSettings';

const links: Link[] = [
  {
    route: 'userProfile',
    text: 'Profile Information',
  },
  {
    route: 'account',
    text: 'Account Settings',
  },
  {
    route: 'notifications',
    text: 'Notification Settings',
  },
];

const SettingsPage = observer(() => {
  const { routeStore, userProfileStore, notificationSettingsStore, authStore } = useRootStore();
  const { route, navigateByName, goHome } = routeStore;
  if (!route) return null;

  return (
    <NavigationPage
      links={links}
      route={route}
      navigateByName={navigateByName}
      onBack={goHome}
      renderBody={() => (
        <>
          {route === 'userProfile' && (
            <UserProfile
              userProfileStore={userProfileStore}
              isInternal={!!authStore?.isInternal}
              authStore={authStore}
            />
          )}
          {route === 'account' && <Account />}
          {route === 'notifications' && <NotificationSettings notificationSettingsStore={notificationSettingsStore} />}
        </>
      )}
    />
  );
});

export { SettingsPage };
